// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__MxhDL","input_container":"TaskForm_input_container__b1tEW"};